import { DEFAULT_LOCALE } from 'settings/constants';

export default DEFAULT_LOCALE;
